import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../context/userContext";
import { useParams } from 'react-router-dom';

import { ContentDetailsInfluencerContainer, UploadImage, Photo, Image } from "./ContentDetailsInfluencerStyled";

import { FormattedMessage, useIntl } from 'react-intl';
import photoVideo from './../../utils/images/photo_video.svg';
import upload from './../../utils/images/upload.svg';
import deleteIcon from './../../utils/images/delete_pink.svg';
import ImageUploading from 'react-images-uploading';
import VideoInput from "../VideoInput/VideoInput";
import { postFileBase64 } from "../../api/fileApi";
import { patchCollaboration, putContentCollaboration, putContentCollaborationStatus } from "../../api/collaborationApi";
import Spinner from "../Spinner/Spinner";
import Alert from "../../components/Alert/Alert";
import Select from 'react-select';
import { contentCollaborationsStatusInfluencer } from "../../utils/constants/general";

export default function ContentDetailsInfluencer({ subItem, type, setShowDispute, activeIndex, setActiveIndex, setShowCarousel, setContentIndex, contentIndex, contentType, setContentType }) {

    //posiciones [0]=id, [1]=content, [2]=status, [3]=readinfluencer, [4]=readcompany
    const intl = useIntl();
    const { idCollaboration } = useParams();

    const [status, setStatus] = useState(parseFloat(subItem?.split(" - ")[2]));
    const [content, setContent] = useState(subItem?.split(" - ")[1]);
    const [idContent, setIdContent] = useState(subItem?.split(" - ")[0]);


    const [images, setImages] = useState([]);
    const maxNumber = 1;

    const [source, setSource] = useState();


    const { userToken, account } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    const [showAlertNotContent, setShowAlertNotContent] = useState(false);

    const isAdmin = sessionStorage.getItem('isAdmin');
    const [statusIndex, setStatusIndex] = useState(status - 1);
    const [contentValue, setContentValue] = useState();

    const [statusOptions, setStatusOptions] = useState(contentCollaborationsStatusInfluencer);

    useEffect(() => {
        const statusUpdate = [];
        setStatusIndex(status - 1);
        setContentValue(statusOptions[status - 1]);
        if (status === 3) {
            statusOptions.map((status, index) => {
                /**Podria agregar el 6 si no puedo hacer disputa sin subir contenido */
                if (index < 2 || index === 4 || index === 5) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 4) {
            statusOptions.map((status, index) => {
                if (index < 6) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 5) {
            statusOptions.map((status, index) => {
                if (index < 5) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 6) {
            statusOptions.map((status, index) => {
                if (index < 5) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 7) {
            statusOptions.map((status, index) => {
                if (index < 7) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else {
            statusOptions.map((status) => {
                statusUpdate.push({ ...status, isDisabled: true })
            })
        }
        setStatusOptions(statusUpdate);
    }, [status])

    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
    };

    const handlerUpload = () => {

        if (images.length > 0 || source !== undefined) {
            setIsLoading(true)

            let fileBody = {}

            if (type === 'photo') {
                fileBody = {
                    base64File: images[0].data_url.split(',')[1],
                    formatFile: images[0].file.type.split('/')[1],
                    address: `fluincr/${account}/collaboration`
                }
            } else {
                fileBody = {
                    base64File: source.data_url.split(',')[1],
                    formatFile: source.file.type.split('/')[1],
                    address: `fluincr/${account}/collaboration`
                }
            }

            postFileBase64({ body: fileBody, token: userToken }).then((responseFile) => {
                if (responseFile.length > 0) {

                    const contentBody = {
                        itemId: idContent,
                        content: responseFile
                    }
                    setContent(responseFile)
                    putContentCollaboration({ contentBody: contentBody, token: userToken }).then((response) => {
                        if (response) {

                            const collaborationBody = {
                                readcompany: false
                            }
                            patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody })

                            putContentCollaborationStatus({ contentId: idContent, newStatus: 4, token: userToken }).then((response) => {
                                setStatus(4)
                                setIsLoading(false);
                                //cambiar el readcompany del item a false
                            })
                        }

                    })
                }
            })
        } else {
            setShowAlertNotContent(true)
            setIsLoading(false);
        }

    }

    const handlerPostedContent = () => {
        setIsLoading(true)
        const collaborationBody = {
            readcompany: false
        }
        patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody })

        putContentCollaborationStatus({ contentId: idContent, newStatus: 6, token: userToken }).then((response) => {
            setStatus(6)
            setIsLoading(false);
            //cambiar el readcompany del item a false
        })
    }

    const adminChangeStatus = ({ contentId, newStatus }) => {

        setIsLoading(true);
        if (newStatus === 4) {
            handlerUpload();
        } else if (newStatus === 7) {
            setIsLoading(false);
            setShowDispute(true);
        } else {
            putContentCollaborationStatus({ contentId: idContent, newStatus: newStatus, token: userToken }).then((response) => {
                setIsLoading(false);
                if (response.status === 200) {
                    setStatus(newStatus)
                } else if (response.status === 409) {
                    window.alert("You don't have permissions to do that action")
                }
                //cambiar el readcompany del item a false
            })
        }
    }

    const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', width: '180px'

        }),
        menu: (styles) => ({
            ...styles, display: 'flex'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        }),
        menuList: (styles) => ({
            ...styles, width: '180px'
        })
    };

    return (
        <ContentDetailsInfluencerContainer>

            {(JSON.parse(isAdmin) === true) ? (<div className="adminSelect">
                <Select options={statusOptions}
                    styles={selectStyles}
                    placeholder={intl.formatMessage({ id: "collaboracion_status_title" })}
                    //defaultValue={statusOptions[statusIndex]}
                    value={contentValue}
                    onChange={(event) => {
                        adminChangeStatus({ contentId: idContent, newStatus: event.value })
                    }} />
            </div>) : (<>
                {(status === 1) ? (
                    <div className="statusTextContainer" >
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_1" defaultMessage="Aceptación pendiente" /></p>
                    </div>
                ) : (status === 2) ? (
                    <div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_2" defaultMessage="Declinado (cerrado)" /></p>
                    </div>
                ) : (status === 3) ? (
                    <div className="statusTextContainer" onClick={handlerUpload} >
                        <p className="status statusButton"><FormattedMessage id="collaboration_details_status_influencer_3" defaultMessage="Sube contenido y click" /></p>
                    </div>
                ) : (status === 4) ? (
                    <div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_4" defaultMessage="Aprobación pendiente" /></p>
                    </div>
                ) : (status === 5) ? (
                    <div className="statusTextContainer">
                        <p className="status statusButton" onClick={handlerPostedContent}><FormattedMessage id="collaboration_details_status_influencer_5" defaultMessage="Publica contenido y click" /></p>
                    </div>
                ) : (status === 6) ? (
                    <div className="statusTextContainer" >
                        <p className="status statusButton" onClick={() => setShowDispute(true)}><FormattedMessage id="collaboration_details_status_influencer_6" defaultMessage="Ventana de disputa" /></p>
                    </div>
                ) : (status === 7) ? (
                    <div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_7" defaultMessage="En espera" /></p>
                    </div>
                ) : (status === 8) ? (
                    <div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_8" defaultMessage="Terminado" /></p>
                    </div>
                ) : (status === 9) && (<div className="statusTextContainer">
                    <p className="status"><FormattedMessage id="collaboration_details_status_influencer_9" defaultMessage="Cancelado" /></p>
                </div>
                )}
            </>)}

            {/**Opción para ver contenido ((status === 1 || status === 2 || status === 3) && content === 'empty' )*/}

            {(status === 1 || status === 2 || status === 3) ? (
                <UploadImage status={status} >
                    {(type === 'photo') ? (
                        <ImageUploading
                            value={images}
                            onChange={onChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                        >
                            {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                            }) => (

                                <div className="upload__image-wrapper">
                                    {(images.length < 1) && (<button
                                        style={isDragging ? { color: 'red' } : undefined}
                                        onClick={onImageUpload}
                                        {...dragProps}
                                        disabled={status === 1 || status === 2}
                                        className="uploadButton"
                                    >
                                        <img src={upload} alt="content" className="uploadItem" />
                                    </button>)}

                                    &nbsp;
                                    {/* <button onClick={onImageRemoveAll}>Remove all images</button> */}
                                    {imageList.map((image, index) => (
                                        <div key={index} className="image-item">

                                            {/* <img src={image['data_url']} alt="" className="photo" /> */}

                                            <Photo image={image['data_url']} />

                                            <div className="image-item__btn-wrapper">
                                                {/* <button onClick={() => onImageUpdate(index)}>Update</button> */}
                                                <button onClick={() => onImageRemove(index)} className="removeButton"><img src={deleteIcon} alt="remove" /></button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </ImageUploading>
                    ) : (<VideoInput status={status} source={source} setSource={setSource} />)}

                </UploadImage>

            ) : (content !== 'empty') ? (
                <div className="content" >
                    {(type === 'photo') ? (<>{/* <a href={content} download> */}
                        <Image image={content} onClick={() => {
                            setActiveIndex(activeIndex)
                            setContentIndex(contentIndex);
                            setContentType(contentType);
                            setShowCarousel(true);
                        }} />
                        {/* </a> */} </>) : (
                        <>
                            {/* <a href={content} download> */}
                            <video
                                className="video"
                                //controls
                                src={content}
                                onClick={() => {
                                    setActiveIndex(activeIndex)
                                    setContentIndex(contentIndex);
                                    setContentType(contentType);
                                    setShowCarousel(true);
                                }}
                            />
                            {/* </a>  */}
                        </>
                    )}

                </div>
            ) : (<div className="notContent">
                <img src={photoVideo} alt="video" />
            </div>)}

            {(isLoading) && (<Spinner />)}

            {(showAlertNotContent) && (<Alert
                title={<FormattedMessage id="alert_not_content_title" defaultMessage="Sin contenido!" />}
                text={<FormattedMessage id="alert_not_content_text" defaultMessage="Por favor carga un archivo en ⬆️ y presiona el botón Sube contenido" />}

                setShowAlert={setShowAlertNotContent}

            />)}

        </ContentDetailsInfluencerContainer>
    )
}